import apiUrl from './../../../../constants';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import Pagination from './../../../shared/components/pagination';
//import VueElementLoading from 'vue-element-loading';
import {BasicSelect,  MultiSelect} from 'vue-search-select'
import vueMultiSelect from 'vue-multi-select';
import 'vue-multi-select/dist/lib/vue-multi-select.css';
import Utility from './../../../utility/services/utility.service';
import Loader from './../../../shared/components/loader'
import Treeselect from '@riophae/vue-treeselect';
import CustomExpandableTable from '../../../shared/components/customExpandableTable';
import CONSTANT from './../../../shared/constants/constant';
import Util from './../../../shared/util/util';
import DatePicker from 'vue2-datepicker';
import moment from "moment";

export default {
  name: 'pendingewbn',
  components: {
    //VueElementLoading,
    Treeselect,
    DatePicker,
    Pagination,
    BasicSelect,
    CustomExpandableTable,
    Util,
    Utility,
    vueMultiSelect,
    Loader
  },
  data: function() {
    return {
      currentPage: 1,
      totalPage: 0,
      totalCount:0,
      offset:0,
      pageLimit:CONSTANT.PER_PAGE_DATA,
      awb: '',
      fromdate:null,
      todate:null,
      ewbn:'',
      isLoading:false,
      tableColumn: [ 'AWB', 'EWBN','Invoice Value','Invoice Number','Created Date'],
      innerTableColumn: ['Assigned Territory'],
      tableItems: [],

    }
  },
  computed: {

  },
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userName = userdetail.email;
    this.getPendigEWBNListing();
  },
  methods: {
    clearForm() {
      this.currentPage =  1,
      this.awb = '';
      this.ewbn = '';
      this.fromdate = "";
      this.todate = "";
      this.getPendigEWBNListing();
      this.$validator.reset();
    },
    onPageChange(page) {
      this.currentPage = page;
      this.offset = (page - 1) *this.pageLimit
      this.getPendigEWBNListing()
    },
    searchPendigEWB(){
      this.currentPage = 1;
      this.offset = 0;
      this.getPendigEWBNListing();
    },

    getCustomTableEvent(event) {

    },
    async getPendigEWBNListing(){
      try {
        this.isLoading = true;
        let inputPayload = {
          "PageNumber":  this.offset == 0 ? 1 : this.offset,
          "PageSize": this.pageLimit
        }
        if(this.fromdate!=null && this.fromdate!="" ){
          inputPayload.fromDate =  moment(this.fromdate).tz('Asia/Kolkata').format('YYYY-MM-DD');
        }
        if(this.todate!=null && this.todate!=""){
          inputPayload.toDate = moment(this.todate).tz('Asia/Kolkata').format('YYYY-MM-DD');
        }
        if(this.ewbn!=""){
          inputPayload.ewbn = this.ewbn;
        }
        if(this.awb!=""){
          inputPayload.awb = this.awb;
        }
        let result = await Utility.getPendingEWBNSListing(inputPayload)
        if(result.data.code == 200){
        this.isLoading = false;
        this.tableItems = result.data.message.map((el)=>{
          return {
            'id':1,
            'AWB':el.AWBNumber,
            'EWBN': el.EBNNumber,
            'Invoice Number':el.InvoiceNumber,
           'Invoice Value':el.InvoiceValue,
            'Created Date':Util.displayDateTimeFormat(el.CreatedDate),
            'Action': 'Need To Check1'
          }
        })
        this.todateerr = ""
        this.totalCount = result.data.message.length;
        this.resultCount = result.data.message.length;
        if (this.totalCount < this.pageLimit) {
          this.totalPage = 1
        } else {
          this.totalPage = Math.ceil(this.totalCount / this.pageLimit);
        }
        this.isLoading = false
      }else{
        this.$alertify.error(result.data.message);
        this.isLoading = false
      }
        //console.log(result);
      } catch(err){
        console.log(err);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/utility/views/pendingEWBN/pendingEWBN.component.js